import { Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    root: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      borderRadius: "0px 40px 40px 0px",
      backgroundColor: "#00538b",
      height: "3rem",
    },
  }));

const Cardazul = ({img,label,value,ext}) => {
    const classes = useStyles();
return(
    <Grid
        item
        container
        xs={4}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={3}>
          <img src={img} width="120%" />
        </Grid>
        <Grid item xs={9}>
          <Paper className={classes.root}>
            <Typography style={{ color: "#ffffff" }}>
              {label}
            </Typography>
            <Typography
              variant="h5"
              style={{ color: "#ffffff", marginLeft: "2rem" }}
            >
              {value}{ext}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
);
};
export default Cardazul;